import { render } from "./GamesFilter.vue?vue&type=template&id=a9a460a8"
import script from "./GamesFilter.vue?vue&type=script&lang=js"
export * from "./GamesFilter.vue?vue&type=script&lang=js"

import "./GamesFilter.vue?vue&type=style&index=0&id=a9a460a8&lang=css"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__